module.exports = __webpack_public_path__ + "static/img/de.a7b2878.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/shipIcons/mipmap-xxxhdpi/de.png
// module id = AdcP
// module chunks = 18